import type { CSSProperties } from "react";
import type { StatusLine } from "../data/status";

const DASH: Record<StatusLine, string | undefined> = {
  solid: undefined,
  dashed: "4 3",
  dotted: "0 3.5"
};

/**
 * A thin circle whose stroke style (solid, dashed, dotted) carries app status.
 * `diameter` is the circle's outer size in px.
 */
export function StatusMark({
  line,
  diameter,
  color,
  className,
  style
}: {
  line: StatusLine;
  diameter: number;
  color: string;
  className?: string;
  style?: CSSProperties;
}) {
  const strokeWidth = line === "dotted" ? 1.6 : 1.2;
  const r = (diameter - strokeWidth) / 2;
  return (
    <svg
      width={diameter}
      height={diameter}
      viewBox={`0 0 ${diameter} ${diameter}`}
      className={className}
      style={style}
      aria-hidden="true"
    >
      <circle
        cx={diameter / 2}
        cy={diameter / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={DASH[line]}
        strokeLinecap={line === "dotted" ? "round" : "butt"}
      />
    </svg>
  );
}
